import { useState } from 'react'

import styles from './index.module.scss'
import CampaignBannerPc from '../../public/campaign_banner_default_pc.png'
import CampaignBannerSp from '../../public/campaign_banner_default_sp.png'

import { AwardContentReskilling } from '../AwardContentReskilling'

type Props = {
  isPc: boolean
}

export const AwardContentSection = ({ isPc }: Props) => {
  const [showCampaignDetail, setShowCampaignDetail] = useState<boolean>(false)

  const toggleCampaignDetail = () => {
    setShowCampaignDetail(!showCampaignDetail)
  }

  const campaignDetails = {
    description: [
      '※ Wチャンスは体験レッスンへの予約申し込みがキャンペーン実施期間内であれば、実際にご参加される日がキャンペーン実施期間を過ぎていても対象となります。9月末までにご参加いただいた方が対象です。',
      '※ 過去参加者限定入会キャンペーンの方も対象となります。',
      '※ Wチャンスは8月8日〜8月14日にキャンペーンに申し込み、9月末までに無料体験レッスンに参加された方が抽選対象となります。',
      '※ プレゼントキャンペーンへの応募は、無料体験レッスン予約完了後に届くメールに記載のエントリーフォームからご応募ください。',
    ],
  }

  return (
    <div className={styles.container}>
      <AwardContentReskilling isPc={isPc} />
      <div className={styles.campaignContainer}>
        <img src={isPc ? CampaignBannerPc.src : CampaignBannerSp.src} />
        <div className={styles.detailsWrapper}>
          <div className={styles.toggleButton} onClick={toggleCampaignDetail}>
            <span>※</span>
            <span className={styles.underline}>
              詳細は必ずこちらでご確認ください
            </span>
          </div>
          {showCampaignDetail && (
            <div className={styles.campaignDetails}>
              <ul>
                {campaignDetails.description.map((line, index) => (
                  <li key={index} className={styles.detailItem}>
                    {line.replace(/^※\s*/, '')}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
